import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import { createComponent, dynamicAttributes } from '../utils';
import { css } from 'styled-components';
var ImageContainer = createComponent({
    name: 'ImageContainer',
    tag: 'div',
    style: function (_a) {
        var aspectRatio = _a.aspectRatio, styles = _a.styles, borderRadius = _a.borderRadius;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: hidden;\n    width: 100%;\n    max-width: 800px;\n    position: relative;\n    padding-top: ", ";\n    border-radius: ", ";\n    ", "\n  "], ["\n    overflow: hidden;\n    width: 100%;\n    max-width: 800px;\n    position: relative;\n    padding-top: ", ";\n    border-radius: ",
            ";\n    ", "\n  "])), aspectRatio === '1:1' ? '100%' : aspectRatio === '4:3' ? '75%' : aspectRatio === '16:9' && '56.25%', borderRadius === 'sm'
            ? '4px'
            : borderRadius === 'md'
                ? '6px'
                : borderRadius === 'circle' && '50%', styles);
    },
});
var ImageElement = createComponent({
    name: 'ImageElement',
    tag: 'img',
    style: function (_a) {
        var imagePosition = _a.imagePosition;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    object-fit: cover;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    object-position: ", ";\n  "], ["\n    object-fit: cover;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    object-position: ",
            ";\n  "])), imagePosition === 'top'
            ? '50% top'
            : imagePosition === 'center'
                ? '50% 50%'
                : imagePosition === 'bottom' && '50% bottom');
    },
});
export var Image = function (_a) {
    var className = _a.className, alt = _a.alt, src = _a.src, _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '1:1' : _b, borderRadius = _a.borderRadius, _c = _a.imagePosition, imagePosition = _c === void 0 ? 'top' : _c, styles = _a.styles, _d = _a.dataQa, dataQa = _d === void 0 ? '' : _d;
    return (React.createElement(ImageContainer, { styles: styles, aspectRatio: aspectRatio, borderRadius: borderRadius, className: className },
        React.createElement(ImageElement, __assign({ src: src, alt: alt, imagePosition: imagePosition }, dynamicAttributes('data-qa', dataQa)))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Image.js.map